<template>
<div>
  <vx-card>

    <vs-row class=" w-full mb-4 py-2">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title h-full" vs-type="flex" vs-align="flex-start"><h5>팝업타입</h5></vs-col>
        <vs-col >
          <vs-row class="mb-4">
            <vs-checkbox>결재</vs-checkbox>
          </vs-row>
          <vs-row class="mb-4">
            <vs-checkbox>합의</vs-checkbox>
          </vs-row>
          <vs-row class="mb-4">
            <vs-checkbox>후결</vs-checkbox>
            <p class="title-hint">후결자는 승인만 가능</p>
          </vs-row>
          <vs-row class="mb-4">
            <vs-checkbox>전결</vs-checkbox>
            <p class="title-hint">내부결재의 경우 전결시점에 결재문서는 완료되고, 협조문의 경우 전결 시점에 기안부서 결재가 완성되고 수신부서로 결재문서가 전달됩니다.</p>
          </vs-row>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>보류</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_reservation" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>자가결재</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_selfpass" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>목록삭제</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_list_removeable" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>일괄삭제</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_removeall" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>문서수정</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_doc_edit" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>개인보관함</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_personal_storage" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>서명이미지</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_sign_image" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>댓글기능</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_commandable" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>결재취소</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_cancelable" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>기안자 의견</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_opinion" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>회사 로고</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_logo" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4 py-2">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title h-full" vs-type="flex" vs-align="flex-start"><h5>문서번호</h5></vs-col>
        <vs-col >
          <vs-row class="mb-4">
            <vs-radio v-model="doc_number_format" vs-value="doc_number_format:1">등록년월일-문서일련번호 4자리</vs-radio>
            <p class="title-hint">ex)  20200901-0000</p>
          </vs-row>
          <vs-row class="mb-4">
            <vs-radio v-model="doc_number_format" vs-value="doc_number_format:2">문서일련번호 10자리</vs-radio>
            <p class="title-hint">ex) 0000000000</p>
          </vs-row>
          <vs-row class="mb-4">
            <vs-radio v-model="doc_number_format" vs-value="doc_number_format:3">등록자소속팀+등록월일+“-”+문서일련번호 4자리</vs-radio>
            <p class="title-hint">ex) 회계팀0901-0000</p>
          </vs-row>
          <vs-row class="mb-4">
            <vs-radio v-model="doc_number_format" vs-value="doc_number_format:4">등록자소속팀+등록월일+문서일렬번호 3자리</vs-radio>
            <p class="title-hint">ex) 회계팀0901000</p>
          </vs-row>
          <vs-row class="mb-4">
            <vs-radio v-model="doc_number_format" vs-value="doc_number_format:5">등록자소속팀+“-”+문서일렬번호 10자리</vs-radio>
            <p class="title-hint">ex) 회계팀-0000000000</p>
          </vs-row>
          <vs-row class="mb-4">
            <vs-radio v-model="doc_number_format" vs-value="doc_number_format:6">등록자소속팀+“-”+년도+문서일렬번호 6자리</vs-radio>
            <p class="title-hint">ex) 회계팀-2020000000</p>
          </vs-row>
          <vs-row class="mb-4">
            <vs-radio v-model="doc_number_format" vs-value="doc_number_format:7">직접설정</vs-radio>
            <p class="title-hint">사용자가 직접 문서채번방식 설정 (회사명 또는 팀명이 변경되면 일렬번호는 새로 채번되며, 문서일렬번호는 마지막 항목에 있어야합니다.)</p>
          </vs-row>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>문서번호 시점</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-radio class="mr-6" v-model="use_doc_time" vs-value="use_doc_time:1">기안시점</vs-radio>
          <vs-radio v-model="use_doc_time" vs-value="use_doc_time:2">완료시점</vs-radio>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class="mt-8" vs-justify="center">
      <vs-button class="large mr-4 " color="#EDEDED" text-color="black" type="filled" >취소</vs-button>
      <vs-button class="large" color="secondary" >저장</vs-button>
    </vs-row>

  </vx-card>

</div>
</template>

<script>
export default {
  name: 'General',
  data () {
    return {
      use_reservation: false,
      use_selfpass: false,
      use_list_removeable: false,
      use_removeall: false,
      use_doc_edit : false,
      use_personal_storage : false,
      use_sign_image : false,
      use_commandable : false,
      use_cancelable : false,
      use_opinion : false,
      use_logo : false,
      use_doc_time : 'use_doc_time:1',
      doc_number_format : 'doc_number_format:1'
    }
  }
}
</script>


<style scoped>
.fix-title { width:180px !important; }
.fix-title-small { width:40px !important; }
.title-hint { margin-left:24px; color : #727272; font-size:12px }

</style>
